import { Fragment, useState } from 'react';
import dayjs from 'dayjs';
import {
  Button, Box, Avatar, List, ListItem, ListItemAvatar, ListItemText, DialogTitle, Dialog, Typography, DialogContent,
  TextField, FormControl, OutlinedInput, FormHelperText, InputLabel, FilledInput, Fab, Popover, DialogActions
} from '@mui/material';
import { DataGrid, GridToolbar, GridToolbarContainer,GridToolbarQuickFilter, GridActionsCellItem, GridToolbarDensitySelector, GridToolbarFilterButton, GridToolbarExport, GridToolbarQuickFilterProps, GridToolbarColumnsButton } from '@mui/x-data-grid';
import { useNoticiasQuery, useAddNoticiaMutation, useEditNoticiaMutation, useDeleteNoticiasMutation } from "../../../redux/reducers/noticiasSlice";
import { centsToPesos } from "../../../lib/utils/index.js"
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import Grid from "@mui/material/Grid";
import IconButton from '@mui/material/IconButton';
import CreateIcon from '@mui/icons-material/Create';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import Campaign from '@mui/icons-material/Campaign'
import ModalConfirmation from "../../../components/ModalConfirmation.js";
import { selectCurrentUser } from "../../../redux/reducers/authSlice"
import { gridNumberComparator } from '@mui/x-data-grid';
import { getNoticiasData, addNoticia, editNoticia, deleteNoticia } from "./noticiasSlice.js";
import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import theme from "../../../theme";


export default function IndicesCat() {
  const dispatch = useDispatch();


  const Header = (props) => {
    const fetching = useSelector(state => state.noticias.fetching);
    return (<Fragment>
      <Typography
        variant="h5"
        component="div"
        sx={{
          minWidth: 275, margin: "10px",
          display: 'flex',
          alignItems: 'center'
        }}
      >
        <Campaign sx={{ marginRight: '5px', color: theme.palette.secondary.dark }} /> Noticias</Typography>
      {fetching > 0 && <p>Cargando</p>}
    </Fragment>);
  };



  const NoticiasTable = (props) => {
    const noticias = useSelector(state => state.noticias.data.noticias);
    useEffect(() => { dispatch(getNoticiasData()) }, []);
    function InputFile(props) {
      return (
        <label htmlFor={props.id || props.title}>
          <input
            style={{ display: "none" }}
            id={props.id || props.title}
            name="upload-photo"
            type="file"
            onChange={props.onChange}
          />
          <Fab
            color="primary"
            size="small"
            component="span"
            aria-label="add"
            variant="extended"
            sx={{ fontWeight: "bold", color: "white" }}
          >
            <AddIcon /> {props.title}
          </Fab>

        </label>
      )
    }
    const currentUser = useSelector(selectCurrentUser);
    const [selectedNews, setSelectedNews] = useState([]);
    const [showNuevoItemForm, setShowNuevoItemForm] = useState(false);
    const [formNoticiaIsOpen, setFormNoticiaIsOpen] = useState(false);

    const [deleteModalConfirmation, setDeleteModalConfirmation] = useState(false);

    const openForm = () => setShowNuevoItemForm(true);
    const closeForm = () => setShowNuevoItemForm(false);

    const NuevaNoticiaForm = () => {
      const [noticia, setNoticia] = useState({});
      const [formErrors, setFormErrors] = useState("");
      const handleSubmit = () => {
        if (!noticia.titulo) return setFormErrors("Debe ingresar un título");
        if (!noticia.cuerpo) return setFormErrors("Debe ingresar un cuerpo");
        if (!noticia.seudonimo) return setFormErrors("Debe ingresar un seudónimo");
        if (!noticia.imagenPrincipal) return setFormErrors("Debe elegir una imagen principal");

        const newNoticia = new FormData();
        newNoticia.append("titulo", noticia.titulo);
        newNoticia.append("seudonimo", noticia.seudonimo);
        newNoticia.append("cuerpo", noticia.cuerpo);
        newNoticia.append("imagenPrincipal", noticia.imagenPrincipal);
        if (noticia.imagenSecundaria) {
          newNoticia.append("imagenSecundaria", noticia.imagenSecundaria);
        }

        dispatch(addNoticia(newNoticia)).unwrap()
          .then(console.log)
          .catch(console.error)
      }

      return (
        <Dialog
          onClose={closeForm} open={showNuevoItemForm}
          minWidth="md"
        >
          <DialogTitle fontWeight={700} style={{ backgroundColor: theme.palette.success.main, color: 'white' }}>Nueva Noticia:</DialogTitle>
          <DialogContent dividers>
            <Grid container>

              <Grid item xs={12}>

                <OutlinedInput
                  fullWidth
                  value={noticia.titulo}
                  onChange={e => setNoticia({ ...noticia, titulo: e.target.value })}
                  required
                  id="outlined-adornment-weight"
                />
                <FormHelperText id="outlined-weight-helper-text">Título</FormHelperText>

                <OutlinedInput
                  id="outlined-adornment-weight"
                  value={noticia.seudonimo}
                  onChange={e => setNoticia({ ...noticia, seudonimo: e.target.value })}
                />
                <FormHelperText id="outlined-weight-helper-text">Seudónimo</FormHelperText>

                <OutlinedInput
                  multiline
                  fullWidth
                  rows={4}
                  id="outlined-adornment-weight"
                  value={noticia.cuerpo}
                  onChange={e => setNoticia({ ...noticia, cuerpo: e.target.value })}
                />
                <FormHelperText id="outlined-weight-helper-text">Cuerpo</FormHelperText>



                <FormControl sx={{ m: 1 }} variant="outlined">
                  <InputFile title={"Elegir Imagen Principal"} id={1} onChange={(e) => setNoticia({ ...noticia, imagenPrincipal: e.target.files[0] })}></InputFile>
                </FormControl>

                <FormControl sx={{ m: 1 }} variant="outlined">
                  <InputFile title={"Elegir Imagen Secundaria"} id={2} onChange={(e) => setNoticia({ ...noticia, imagenSecundaria: e.target.files[0] })}></InputFile>
                </FormControl>

                {formErrors !== "" && <p style={{ color: "red" }}>{formErrors}</p>}

                {noticia.imagenPrincipal && <img style={{ height: '200px' }} src={URL.createObjectURL(noticia.imagenPrincipal)} alt="imagen principal" />}
                {noticia.imagenSecundaria && <img style={{ height: '200px', marginLeft: '20px' }} src={URL.createObjectURL(noticia.imagenSecundaria)} alt="imagen principal" />}
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions style={{ marginTop: '10px' }}>
            <Button variant="contained" onClick={handleSubmit} sx={{ marginRight: '5px', fontWeight: "bold", color: "white" }}>{"Aceptar"}</Button>
            <Button variant="outlined" onClick={closeForm} sx={{ fontWeight: "bold" }}>{"Cancelar"}</Button>
          </DialogActions>
        </Dialog>
      )
    }

    const editNoticiasProps = () => {
      let noticiaSeleccionada = (noticias || [])?.find(n => n.noticiaId === selectedNews.noticiaId)
      return {
        title: "Editar Noticia",
        closeForm: () => setFormNoticiaIsOpen(false),
        dfltValues: noticiaSeleccionada,
        formIsOpen: formNoticiaIsOpen,
        handleSubmit: (noticia) => {
          console.log('1', noticia)
          const noticiaEditada = new FormData();
          noticiaEditada.append("noticiaId", noticia.noticiaId);
          noticiaEditada.append("titulo", noticia.titulo);
          noticiaEditada.append("seudonimo", noticia.seudonimo);
          noticiaEditada.append("cuerpo", noticia.cuerpo);
          if (noticia.imagenPrincipal) noticiaEditada.append("imagenPrincipal", noticia.imagenPrincipal);
          if (noticia.imagenSecundaria) noticiaEditada.append("imagenSecundaria", noticia.imagenSecundaria);
          console.log('2', noticiaEditada)
          dispatch(editNoticia(noticiaEditada)).unwrap()
            .then(console.log)
            .catch(console.error)
        }
      }
    }

    const initDeleteNoticias = async (noticiasIds) => {
      try {
        let res = dispatch(deleteNoticia([noticiasIds])).unwrap();
        console.log(res);
        setSelectedNews([]);
      } catch (error) {
        console.log("error eliminado noticas " + error + " string: " + JSON.stringify(error));
      }
    }
    const GridAction = (props) => {
      const [anchorEl, setAnchorEl] = useState(null);

      const handlePopoverOpen = (event) => {
        setAnchorEl(event.currentTarget)
      };

      const handlePopoverClose = () => {
        setAnchorEl(null)
      };
      const { label, key, Icon } = props;
      const open = Boolean(anchorEl);
      return (
        <Fragment key={key + label}>
          <Icon aria-owns={open ? label : undefined}
            aria-haspopup="true"
            onMouseEnter={handlePopoverOpen}
            onMouseLeave={handlePopoverClose}> </Icon>
          <Popover
            id={label}
            sx={{
              pointerEvents: 'none',
            }}
            open={open}
            anchorEl={anchorEl}
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            transformOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}
            onClose={handlePopoverClose}
            disableRestoreFocus
          >
            <Typography sx={{ p: 1 }}>{label}</Typography>
          </Popover>
        </Fragment>
      )
    };
    const columns = [
      { field: 'noticiasId', headerName: 'ID', hide: true },
      { field: 'titulo', headerName: 'Título', flex: 4 },
      { field: 'cuerpo', headerName: 'Cuerpo', flex: 4, valueGetter: (params) => params.value.substring(0, 50) + '...' },
      { field: 'seudonimo', headerName: 'Seudónimo', flex: 4 },
      { field: 'autorId', headerName: 'Autor', flex: 4 },
      { field: 'imagenPrincipalUrl', headerName: 'Imagen Principal', flex: 4 },
      { field: 'imagenSecundariaUrl', headerName: 'Imagen Secundaria', flex: 4 },
      { field: 'imagenTerciariaUrl', headerName: 'Imagen Terciaria', flex: 4 },
      { field: 'fechaCreacion', headerName: 'Fecha', flex: 2, renderCell: v => (new Date(parseInt(v.row.fechaCreacion))).toLocaleString().split(',')[0] },
      {
        field: 'actions', headerName: 'Acciones', flex: 4, type: 'actions', renderCell: v =>
          <>
            <GridActionsCellItem key={v.row.noticiaId + '-editarGridAction'} disabled={currentUser?.permisos?.includes("writeNoticias") ? false : true} color={'info'} onClick={() => { setFormNoticiaIsOpen(true); setSelectedNews(v.row) }} icon={<GridAction label={'Editar'} key={v.row.noticiaId} Icon={EditIcon} />} />
            <GridActionsCellItem key={v.row.noticiaId + '-borrarGridAction'} disabled={currentUser?.permisos?.includes("writeNoticias") ? false : true} color={'danger'} onClick={() => { setDeleteModalConfirmation(true); setSelectedNews(v.row) }} icon={<GridAction label={'Eliminar'} Icon={DeleteIcon} />} />
          </>
      }
    ];

    function NoticiaForm({ closeForm, formIsOpen, title, dfltValues = {}, handleSubmit }) {
      const [noticia, setNoticia] = useState(dfltValues);

      return (
        <Dialog
          onClose={closeForm} open={formIsOpen}
          minWidth="md"
        >
          <DialogTitle fontWeight={700} style={{ backgroundColor: theme.palette.success.main, color: 'white' }} >{title || "Nueva Noticia:"}</DialogTitle>
          <DialogContent dividers>
            <Grid container>

              <Grid item xs={12}>

                <OutlinedInput
                  fullWidth
                  value={noticia.titulo}
                  onChange={e => setNoticia({ ...noticia, titulo: e.target.value })}
                  required
                  id="outlined-adornment-weight"
                />
                <FormHelperText id="outlined-weight-helper-text">Título</FormHelperText>

                <OutlinedInput
                  id="outlined-adornment-weight"
                  value={noticia.seudonimo}
                  onChange={e => setNoticia({ ...noticia, seudonimo: e.target.value })}
                />
                <FormHelperText id="outlined-weight-helper-text">Seudónimo</FormHelperText>

                <OutlinedInput
                  multiline
                  fullWidth
                  rows={4}
                  id="outlined-adornment-weight"
                  value={noticia.cuerpo}
                  onChange={e => setNoticia({ ...noticia, cuerpo: e.target.value })}
                />
                <FormHelperText id="outlined-weight-helper-text">Cuerpo</FormHelperText>



                <FormControl sx={{ m: 1 }} >
                  <InputFile sx={{ fontWeight: "bold", color: "white" }} title={"Elegir Imagen Principal"} id={1} onChange={(e) => setNoticia({ ...noticia, imagenPrincipal: e.target.files[0] })}></InputFile>
                </FormControl>

                <FormControl sx={{ m: 1 }} >
                  <InputFile sx={{ fontWeight: "bold", color: "white" }} title={"Elegir Imagen Secundaria"} id={2} onChange={(e) => setNoticia({ ...noticia, imagenSecundaria: e.target.files[0] })}></InputFile>
                </FormControl>

                {noticia.imagenPrincipal && <img style={{ height: '200px' }} src={URL.createObjectURL(noticia.imagenPrincipal)} alt="imagen principal" />}
                {!noticia.imagenPrincipal && noticia.imagenPrincipalUrl && <img style={{ height: '200px' }} src={noticia.imagenPrincipalUrl} alt="imagen principal" />}
                {noticia.imagenSecundaria && <img style={{ height: '200px', marginLeft: '20px' }} src={URL.createObjectURL(noticia.imagenSecundaria)} alt="imagen principal" />}
                {!noticia.imagenSecundaria && noticia.imagenSecundariaUrl && <img style={{ height: '200px' }} src={noticia.imagenSecundariaUrl} alt="imagen secundaria" />}
              </Grid>



            </Grid>
          </DialogContent>
          <DialogActions style={{ marginTop: '10px' }}>
            <Button variant="contained" onClick={() => handleSubmit(noticia)} sx={{ marginRight: '5px', fontWeight: "bold", color: "white" }}>{"Aceptar"}</Button>
            <Button variant="outlined" sx={{ fontWeight: "bold" }} onClick={closeForm}>{"Cancelar"}</Button>
          </DialogActions>
        </Dialog>
      );
    }

    const BtnBar = (props) => {

      return (
        <Fragment>
          <Button className="mb-3" variant="contained" color='primary'  sx={{ height: '4vh', width: '15%', fontWeight: 'bold', margin: '0.4em' }}onClick={openForm}>NUEVO<AddIcon/></Button>
          {/* <IconButton className="mb-3" variant="contained" color='primary' onClick={openForm}><AddIcon /></IconButton> */}
          <NuevaNoticiaForm></NuevaNoticiaForm>
        </Fragment>
      );
    };

    return (
      <Fragment>
        <NoticiaForm {...editNoticiasProps()}></NoticiaForm> {/* Nuevo componente generico*/}
        <ModalConfirmation
          title={"Eliminar Noticia"}
          description={"¿Está seguro que desea eliminar la noticia?"}
          open={deleteModalConfirmation}
          handleClose={() => setDeleteModalConfirmation(false)}
          onConfirmation={() => initDeleteNoticias(selectedNews.noticiaId)}
        ></ModalConfirmation>

        <Box sx={{ height: 600, width: '100%' }}>
          <DataGrid
            pagination
            sx={{ height: '75vh', width: '100%' }}
            getRowId={r => r.noticiaId}
            rows={noticias || []}
            columns={columns}
            pageSize={100}
            rowsPerPageOptions={[5]}
            components={{
              Toolbar: () => {
                return <Fragment>
                  <GridToolbarContainer>
                    <Grid conteiner
                      rowSpacing={0} sx={{
                        display: "inline-flex",
                        justifyContent: "space-between",
                        alignItems: "strech",
                        width: "100%"
                      }}>
                      {currentUser?.permisos?.includes('writeNoticias') ?
                        <BtnBar></BtnBar>
                        : null
                      }
                      <Grid sx={{ width: "100%", marginLeft: '1em' }}>
                        <GridToolbarColumnsButton /><GridToolbarFilterButton /> <GridToolbarDensitySelector />
                        {currentUser?.permisos?.includes('export-data') ? <> <GridToolbarExport /> </>
                          : ''}
                      </Grid>
                      <GridToolbarQuickFilter />
                    </Grid>
                  </GridToolbarContainer>
                </Fragment>
              }
            }}
            componentsProps={{
              toolbar: {
                showQuickFilter: true,
                quickFilterProps: { debounceMs: 500 },
              },
            }}
          />
        </Box>
      </Fragment>
    );
  };

  return (
    <Fragment>
      <Header></Header>
      <NoticiasTable></NoticiasTable>
    </Fragment>
  )
}